import { PlusOutlined } from '@ant-design/icons';
import styled, { css } from 'styled-components';

import { Flex } from '@/components/base';
import IconButton from '@/components/Button/IconButton';
import Menu from '@/components/Menu/Menu';
import type { MenuItemProps } from '@/components/Menu/types';
import Typo from '@/components/Typography/Typo';

type Props = {
  alias: string;
  name: string;
  focused?: boolean;
  createOptions: MenuItemProps[];
  onClick?: () => void;
  onCreateTopicClick?: () => void;
};

const TaxonomyRow = (props: Props) => {
  return (
    <Style onClick={props.onClick} g={12} focused={props.focused}>
      <Typo
        type="label1"
        className="text-gray-700"
        weight="sb"
        multilineEllipsis={1}
        style={{ flex: 1 }}
      >
        {props.name}
      </Typo>
      {props.onCreateTopicClick && (
        <Flex className="hover-item">
          <Menu
            triggerNode={
              <IconButton
                tooltip="Add subtopic"
                icon={
                  <PlusOutlined
                    style={{
                      transform: 'translate(-0.5px, -0.5px)',
                    }}
                  />
                }
                css={css`
                  background-color: transparent;
                  color: ${(props) => props.theme.colors.primary100};
                `}
                outlined={false}
              />
            }
            options={props.createOptions}
          />
        </Flex>
      )}
    </Style>
  );
};

type StyleProps = {
  focused?: boolean;
};

const Style = styled(Flex)<StyleProps>`
  position: relative;
  cursor: pointer;
  width: 100%;
  height: 48px;
  align-items: center;
  transition: all 0.2s;
  border-radius: ${(props) => props.theme.radius.token.lg}px;
  border: 1px solid transparent;
  padding: 0px 8px 0px 16px;
  font-size: 20px;
  color: ${(props) => props.theme.colors.primary100};
  flex-shrink: 0;
  ${({ focused }) =>
    focused &&
    css`
      background-color: ${(props) => props.theme.colors.selected};
      border: 1px solid ${(props) => props.theme.colors.primary100};
      &:hover {
        background-color: ${(props) => props.theme.colors.selected_hover};
      }
    `}
  .hover-item {
    opacity: 0;
    transition: all 0.2s;
  }
  &:hover {
    background-color: ${(props) => props.theme.colors.gray200};
    .hover-item {
      opacity: 1;
    }
  }
`;

export default TaxonomyRow;
